<template>
  <div class="password-requirements">
    <div
      v-for="(requirement, index) in requirements"
      :key="index"
      class="requirement-item"
    >
      <v-icon
        :color="
          requirement.valid
            ? $config.dados.successColor
            : $config.dados.errorColor
        "
        small
      >
        {{ requirement.valid ? "mdi-check" : "mdi-close" }}
      </v-icon>
      <span
        :style="{
          color: requirement.valid
            ? $config.dados.successColor
            : $config.dados.errorColor,
        }"
        >{{ requirement.message }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    password: {
      type: String,
      required: true,
    },
  },
  computed: {
    requirements() {
      const senha = this.password || "";
      return [
        {
          valid: senha.length >= 8,
          message: this.$t("common.password-requirements.min-length"),
        },
        {
          valid: /\d/.test(senha),
          message: this.$t("common.password-requirements.min-numbers"),
        },
        {
          valid: /[a-z]/.test(senha),
          message: this.$t(
            "common.password-requirements.min-non-capital-characters"
          ),
        },
        {
          valid: /[A-Z]/.test(senha),
          message: this.$t(
            "common.password-requirements.min-capital-characters"
          ),
        },
        {
          valid: /[!@#$%^&*(),.?":{}|<>_\-+=[\]\\/~']/.test(senha),
          message: this.$t(
            "common.password-requirements.min-special-characters"
          ),
        },
      ];
    },
  },
};
</script>

<style scoped>
.password-requirements {
  margin-top: 8px;
  font-size: 10px;
}
.password-requirements .requirement-item {
  display: flex;
  align-items: center;
}
.password-requirements .requirement-item v-icon {
  font-size: 10px;
  margin-right: 8px;
}
</style>
